import tw, { styled } from "twin.macro";

export const Form = tw.form``;

export const StyledInput = styled.input`
  ${tw`w-full text-body leading-input py-micro border-b outline-none focus:outline-none bg-transparent`}
  ${({ error }) => (error === `true` ? tw`border-warning` : tw`border-grey`)}
`;
